
import { sendPost } from '../http.js'
const api = {
	'couponCreate': {
	    url: '/coupon/create'
	},
    'couponList': {
	    url: '/coupon/list'
	},
    'couponEdit': {
	    url: '/coupon/edit'
	},
    'couponEditList': {
	    url: '/coupon/detail'
	},
    'couponProduct': {
	    url: '/coupon/product'
	},
    'couponDelete': {
	    url: '/coupon/del'
	},
	'couponRecodee': {
	    url: '/coupon/receive/recode'
	},
	
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        mutationsName: api[key].mutationsName,
        requestFun:(params) => {
            return sendPost(api[key].url, params)
        }
    } 
}
export default requestFunObj